export default __webpack_public_path__ + "static/conduct-190a6c178dcf1ad9d7f5007dd658d3e8.jpg";